<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-plus"
        texto-titulo="Nueva Seccion"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Datos:</h5>
                  <form @submit.prevent="guardarSeccion()">
                    <float-label label="Código:" clase>
                      <input
                        v-model="seccion.codigo"
                        id="codigo"
                        placeholder="Ingresar un código..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.seccion.codigo.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="
                            enviado && !$v.seccion.codigo.required
                          "
                        >
                          Debe ingresar un código
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Descripción:" clase="">
                      <input
                        id="descripcion"
                        v-model="seccion.descripcion"
                        placeholder="Ingresar una descripción..."
                        type="text"
                        class="form-control"
                      />
                    </float-label>
                    <button class="mt-1 btn btn-info float-right">
                      Guardar
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from 'vuelidate/lib/validators';
import Seccion from "@/models/seccion";
import axios from "axios";
export default {
  name: "NuevaSeccion",
  components: {
    TituloComponente,
    FloatLabel,
  },
  data() {
    return {
      seccion: new Seccion(null, ""),
    };
  },
  validations:{
    seccion:{
      codigo:{required},
      descripcion:{required},
    }
  },
  methods: {
    guardarSeccion() {
      axios
        .post("/seccion", this.seccion)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarSecciones" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>